import React, { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router';

type Props = {
  children?: ReactNode;
};

export const Scroller: React.FC<Props> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest',
          });
        }, 100);
      }
      return;
    }
    window.scrollTo(0, 0);
  }, [location]);

  return <>{children}</>;
};
